import React from 'react'
import { v4 as uuidv4 } from 'uuid';

const SingleCoCurricular = (props) =>{
    return(
        <li className="subpara-text">{props.element}</li>
    )
}


function CoCurricular(props) {
    return (
        <>
            <section>
                <p className="heading-text">CO-CURRICULAR AND EXTRA-CURRICULAR ACTIVITIES</p>
                <ul type="disc">
                    {
                        props.cocurricular.map((element)=>{
                            return <SingleCoCurricular key={uuidv4()} element={element}/>
                        })
                    }
                </ul>
            </section>
        </>
    )
}

export default CoCurricular
